module.exports = __webpack_public_path__ + "img/plan-a-info-title-01.396138aa.png";